import { createListenerMiddleware } from "@reduxjs/toolkit";

import type { AppStartListening } from "types/AppStartListening";

import { addCoreListeners } from "features/core/store/listeners";
import { addDevicesListeners } from "features/devices/store/listeners";
import { addLiveStreamingListeners } from "features/liveStreaming/store/listeners";
import { addPlaybackListeners } from "features/playback/store/listeners";
import { addCaseViewerListeners } from "features/cases/caseViewer/store/listeners";
import { addCaseManagementListeners } from "features/cases/caseManagement/store/listeners";
import { addCaseExportsListeners } from "features/cases/caseExports/store/listeners";

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening =
    listenerMiddleware.startListening as AppStartListening;

addCoreListeners(startAppListening);
addDevicesListeners(startAppListening);
addLiveStreamingListeners(startAppListening);
addPlaybackListeners(startAppListening);
addCaseViewerListeners(startAppListening);
addCaseManagementListeners(startAppListening);
addCaseExportsListeners(startAppListening);
